import {
    loadUserEmailData,
    loadUserEmailDataSQL,
    loadJobs,
    updateUserDataArray,
    recordLogin,
    saveEquipmentAssets,
    saveEquipmentRates,
    loadJobsNew,
    loadCostHistoryCombined,
    loadJobBillingsCombined,
    loadJobOpenCommitmentsCombined,
    loadUserData,
    loadUserDataCombined,
    loadVersionTeamJob,
    loadOverheadPhaseEquipment,
    loadPhaseCodes,
    loadOverheadData,
    loadVariance,
    loadEquipmentData,
    loadK2Data,
    loadCostDetailCondensed,
    pNum
} from '../db/company';
import { useAtom } from 'jotai';
import {
    jobDataAtom,
    jobUserDataAtom,
    jobOpenCommitmentsAtom,
    jobBillingsAtom,
    jobCostDetailAtom,
    jobCostDetailCondensedAtom,
    dataSourceVersionAtom,
    dataSourceJobsAtom,
    dataSourceTeamsAtom,
    selectedVersionAtom,
    selectedJobAtom,
    testJobsAtom,
    phasedForecastAtom,
    dayZeroAtom,
    projectCompleteAtom,
    authStateAtom,
    jobUserDetailAtom,
    userEmailAtom,
    jobPhaseCodesAtom,
    isLiveVersionAtom,
    overheadDataAtom,
    selectedWIPAtom,
    jobUserDataPrevAtom,
    jobOpenCommitmentsPrevAtom,
    jobBillingsPrevAtom,
    jobCostDetailPrevAtom,
    userNameAtom,
    userIdAtom,
    userIsGoodAtom,
    userRoleAtom,
    userEmailCheckAtom,
    equipmentRatesAtom,
    equipmentDescriptionsAtom,
    budgetDeltaWipAtom,
    equipmentAssetsAtom,
    laborDeltaWipAtom,
    equipmentDeltaWipAtom,
    materialsDeltaWipAtom,
    subDeltaWipAtom,
    otherDeltaWipAtom,
    overheadDeltaWipAtom,
    contingencyDeltaWipAtom,
    dataSourceJobsClosedAtom,
    loadingCostAtom,
    mechanicallyCompleteAtom,
    startDateActualAtom,
    jobLoadedAtom,
    k2DataAtom,
    varianceHistoryAtom
} from '../store/company';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { apiStatusAtom } from '../store/apiStatus';

const version74TeamMapping = {
    "10124013": "GULF COAST",
    "10124016": "GULF COAST",
    "11623082": "PICKETT",
    "11624024": "PICKETT",
    "11624032": "PICKETT",
    "11624038": "PICKETT",
    "11624135": "PICKETT",
    "11624169": "PICKETT",
    "11624184": "PICKETT",
    "11624198": "PICKETT",
    "11624222": "PICKETT",
    "11624230": "PICKETT",
    "11624231": "PICKETT",
    "11624236": "PICKETT",
    "11624276": "PICKETT",
    "11624314": "PICKETT",
    "11625061": "PICKETT",
    "11625062": "PICKETT",
    "11625065": "PICKETT",
    "11625066": "PICKETT",
    "11625067": "PICKETT",
    "11625069": "PICKETT",
    "11625074": "PICKETT",
    "11625080": "PICKETT",
    "11625084": "PICKETT",
    "11625085": "PICKETT",
    "11625095": "PICKETT",
    "11625098": "PICKETT",
    "11625104": "PICKETT",
    "11625105": "PICKETT",
    "11625113": "PICKETT",
    "11625114": "PICKETT",
    "11625115": "PICKETT",
    "11625119": "PICKETT",
    "11625120": "PICKETT",
    "11625121": "PICKETT",
    "11625122": "PICKETT",
    "11625123": "PICKETT",
    "11625124": "PICKETT",
    "11625125": "PICKETT",
    "11625126": "PICKETT",
    "11625127": "PICKETT",
    "11625128": "PICKETT",
    "11625129": "PICKETT",
    "11625130": "PICKETT",
    "11625136": "PICKETT",
    "11625139": "PICKETT",
    "11625140": "PICKETT",
    "11625144": "PICKETT",
    "11625145": "PICKETT",
    "11625146": "PICKETT",
    "11625147": "PICKETT",
    "11625148": "PICKETT",
    "11625149": "PICKETT",
    "11625150": "PICKETT",
    "11625151": "PICKETT",
    "11625152": "PICKETT",
    "11625154": "PICKETT",
    "11625155": "PICKETT",
    "11625156": "PICKETT",
    "11625157": "PICKETT",
    "11625158": "PICKETT",
    "11625159": "PICKETT",
    "11625160": "PICKETT",
    "11625161": "PICKETT",
    "11625162": "PICKETT",
    "11625163": "PICKETT",
    "11625164": "PICKETT",
    "11625165": "PICKETT",
    "11625166": "PICKETT",
    "11625167": "PICKETT",
    "11625170": "PICKETT",
    "11625171": "PICKETT",
    "11625172": "PICKETT",
    "11625173": "PICKETT",
    "11625174": "PICKETT",
    "11625175": "PICKETT",
    "11625176": "PICKETT",
    "11625177": "PICKETT",
    "11625178": "PICKETT",
    "11625179": "PICKETT",
    "11625180": "PICKETT",
    "11625181": "PICKETT",
    "11625182": "PICKETT",
    "11625183": "PICKETT",
    "11625184": "PICKETT",
    "11625185": "PICKETT",
    "11625186": "PICKETT",
    "11625187": "PICKETT",
    "11625189": "PICKETT",
    "11625190": "PICKETT",
    "11625191": "PICKETT",
    "11625192": "PICKETT",
    "11625193": "PICKETT",
    "11625194": "PICKETT",
    "11625195": "PICKETT",
    "11625200": "PICKETT",
    "11625201": "PICKETT",
    "11625202": "PICKETT",
    "11625203": "PICKETT",
    "11625204": "PICKETT",
    "11625205": "PICKETT",
    "11625206": "PICKETT",
    "11625207": "PICKETT",
    "11625210": "PICKETT",
    "11625211": "PICKETT",
    "11625212": "PICKETT",
    "11625213": "PICKETT",
    "11625214": "PICKETT",
    "11625215": "PICKETT",
    "11625216": "PICKETT",
    "11625217": "PICKETT",
    "11625218": "PICKETT",
    "11625219": "PICKETT",
    "11625220": "PICKETT",
    "11625221": "PICKETT",
    "11625222": "PICKETT",
    "11625223": "PICKETT",
    "11625224": "PICKETT",
    "11625225": "PICKETT",
    "11625226": "PICKETT",
    "11625227": "PICKETT",
    "11625228": "PICKETT",
    "11625229": "PICKETT",
    "11625230": "PICKETT",
    "11625231": "PICKETT",
    "11625232": "PICKETT",
    "11625233": "PICKETT",
    "11625234": "PICKETT",
    "11625235": "PICKETT",
    "11625236": "PICKETT",
    "11625237": "PICKETT",
    "11625238": "PICKETT",
    "11625239": "PICKETT",
    "11625240": "PICKETT",
    "11625241": "PICKETT",
    "11625242": "PICKETT",
    "11625243": "PICKETT",
    "12424007": "GULF COAST",
    "12424011": "GULF COAST",
    "12424015": "GULF COAST",
    "12424027": "GULF COAST",
    "12424031": "GULF COAST",
    "12424034": "GULF COAST",
    "12424038": "GULF COAST",
    "12424039": "GULF COAST",
    "12424040": "GULF COAST",
    "12424041": "GULF COAST",
    "12424042": "GULF COAST",
    "12424043": "GULF COAST",
    "12425002": "GULF COAST",
    "12425003": "GULF COAST",
    "12425004": "GULF COAST",
    "12425005": "GULF COAST",
    "12425006": "GULF COAST",
    "12425007": "GULF COAST",
    "12425009": "GULF COAST",
    "12425011": "GULF COAST",
    "12425012": "GULF COAST",
    "12425013": "GULF COAST",
    "12425014": "GULF COAST",
    "12425016": "GULF COAST",
    "12425019": "GULF COAST",
    "12425023": "GULF COAST",
    "12425025": "GULF COAST",
    "12425026": "GULF COAST",
    "12425027": "GULF COAST",
    "12425028": "GULF COAST",
    "12425029": "GULF COAST",
    "12425030": "GULF COAST",
    "12425031": "GULF COAST",
    "12425032": "GULF COAST",
    "12425033": "GULF COAST",
    "12425034": "GULF COAST",
    "12425035": "GULF COAST",
    "12425036": "GULF COAST",
    "12425037": "GULF COAST",
    "12425038": "GULF COAST",
    "12425039": "GULF COAST",
    "12425040": "GULF COAST",
    "12425041": "GULF COAST",
    "12425042": "GULF COAST",
    "12425044": "GULF COAST",
    "12425045": "GULF COAST",
    "12425046": "GULF COAST",
    "12425047": "GULF COAST",
    "12425048": "GULF COAST",
    "12425049": "GULF COAST",
    "12425050": "GULF COAST",
    "13523002": "FACILITIES",
    "13524021": "TERMINALS",
    "13525003": "FACILITIES",
    "13525005": "FACILITIES",
    "13525006": "FACILITIES",
    "13525007": "FACILITIES",
    "15524004": "TERMINALS",
    "15524008": "TERMINALS",
    "15524009": "TERMINALS",
    "15524013": "TERMINALS",
    "15525002": "TERMINALS",
    "15525003": "TERMINALS",
    "16124016": "BOLT",
    "16125002": "BOLT",
    "16125003": "BOLT",
    "16125004": "BOLT",
    "16125005": "BOLT",
    "16125006": "BOLT",
    "16125007": "BOLT",
    "50224022": "NOR",
    "50224035": "NOR",
    "50225003": "NOR",
    "50225004": "NOR",
    "50225005": "NOR",
    "50225006": "NOR",
    "50225007": "NOR",
    "50225008": "NOR",
    "50225009": "NOR",
    "50225011": "NOR",
    "50225012": "NOR",
    "50225013": "NOR",
    "50225016": "NOR",
    "50225017": "NOR",
    "50225018": "NOR",
    "50225019": "NOR",
    "50225021": "NOR",
    "50225022": "NOR",
    "50225023": "NOR",
    "50225024": "NOR",
    "50225025": "NOR",
    "50225026": "NOR",
    "50225027": "NOR",
    "50424004": "ETX",
    "50424007": "ETX",
    "50424009": "ETX",
    "50424010": "ETX",
    "50424017": "ETX",
    "50425002": "ETX",
    "50425003": "ETX",
    "50425004": "ETX",
    "50425005": "ETX",
    "50425006": "ETX",
    "50425007": "ETX",
    "50425008": "ETX",
    "50425009": "ETX",
    "50425010": "ETX",
    "50425011": "ETX",
    "50425014": "ETX",
    "50425020": "ETX",
    "50425023": "ETX",
    "50425027": "ETX",
    "50425032": "ETX",
    "50425035": "ETX",
    "50425036": "ETX",
    "54024021": "WTX",
    "54024036": "WTX",
    "54024042": "WTX",
    "54024061": "WTX",
    "54024064": "WTX",
    "54024071": "WTX",
    "54024073": "WTX",
    "54024082": "WTX",
    "54024088": "WTX",
    "54024089": "WTX",
    "54024090": "WTX",
    "54024091": "WTX",
    "54024093": "WTX",
    "54024094": "WTX",
    "54024095": "WTX",
    "54024098": "WTX",
    "54024099": "WTX",
    "54024100": "WTX",
    "54024103": "WTX",
    "54025002": "WTX",
    "54025004": "WTX",
    "54025005": "WTX",
    "54025006": "WTX",
    "54025007": "WTX",
    "54025009": "WTX",
    "54025010": "WTX",
    "54025013": "WTX",
    "54025014": "WTX",
    "54025015": "WTX",
    "54025018": "WTX",
    "54025020": "WTX",
    "54025021": "WTX",
    "54025022": "WTX",
    "54025023": "WTX",
    "54025025": "WTX",
    "54025028": "WTX",
    "54025029": "WTX",
    "54025032": "WTX",
    "54025033": "WTX",
    "54025035": "WTX",
    "54025036": "WTX",
    "54025037": "WTX",
    "54025038": "WTX",
    "54025039": "WTX",
    "54025040": "WTX",
    "54025041": "WTX",
    "54025042": "WTX",
    "54025043": "WTX",
    "54025044": "WTX",
    "54025045": "WTX",
    "54025047": "WTX",
    "54025048": "WTX",
    "54025049": "WTX",
    "54025050": "WTX",
    "54025052": "WTX",
    "54025054": "WTX",
    "54025055": "WTX",
    "54025056": "WTX",
    "54025057": "WTX",
    "54025058": "WTX",
    "54025059": "WTX",
    "54025060": "WTX",
    "54025061": "WTX",
    "54025062": "WTX",
    "54025063": "WTX",
    "54025064": "WTX",
    "54025065": "WTX",
    "54025067": "WTX",
    "54025068": "WTX",
    "54025069": "WTX",
    "54025070": "WTX",
    "54025071": "WTX",
    "54025072": "WTX",
    "54025073": "WTX",
    "54025074": "WTX",
    "54025075": "WTX",
    "54025076": "WTX",
    "54025077": "WTX",
    "54025078": "WTX",
    "54025079": "WTX",
    "54025080": "WTX",
    "54025081": "WTX",
    "54025082": "WTX",
    "54025083": "WTX",
    "54025084": "WTX",
    "54025085": "WTX",
    "54025086": "WTX",
    "54025087": "WTX",
    "54025088": "WTX",
    "54025089": "WTX",
    "54025090": "WTX",
    "54025091": "WTX",
    "54025092": "WTX",
    "54025093": "WTX",
    "54025094": "WTX",
    "54025095": "WTX"
};

// Jobs whose JDE codes say phased (Work_Type/Job_Tier 3) but that PC wants forecast by cost type
const forceRegularJobs = ['50425020', '54026065'];

// Jobs forced onto the phased forecast regardless of their JDE codes
const forcePhasedJobs = ['54025034', '50225019', '12425041', '12425045', '12425046', '54025101', '54026014', '54026013', '50226006', '54024091', '54026052', '54026089'];

//Helper function to check if cached data is still valid


const isCacheValid = (timestamp) => {
    if (!timestamp) return false;

    const now = moment();
    const cachedTime = moment(timestamp);

    // Check if less than 24 hours old
    if (now.diff(cachedTime, 'hours') > 1) {
        return false;
    }

    // Check if we're past the last 9am instance
    const last9am = moment().hour(15).minute(0).second(0);
    if (now.isBefore(last9am)) {
        // If it's before 9am today, check against yesterday's 9am
        last9am.subtract(1, 'day');
    }

    return cachedTime.isAfter(last9am);
};

// Helper functions for cache management
const getCachedVersionTeamJob = () => {
    try {
        const cached = localStorage.getItem('versionTeamJobCache');
        if (!cached) return null;

        const parsed = JSON.parse(cached);
        if (isCacheValid(parsed.timestamp)) {
            console.log('Using cached version/team/job data');
            return parsed.data;
        } else {
            console.log('Cache expired, fetching fresh data');
            localStorage.removeItem('versionTeamJobCache');
            return null;
        }
    } catch (err) {
        console.error('Error reading cache:', err);
        return null;
    }
};

const setCachedVersionTeamJob = (data) => {
    try {
        const cacheData = {
            timestamp: moment().toISOString(),
            data: data
        };
        localStorage.setItem('versionTeamJobCache', JSON.stringify(cacheData));
        console.log('Cached version/team/job data');
    } catch (err) {
        console.error('Error setting cache:', err);
    }
};

const LoadData = () => {
    const [jobData, setJobData] = useAtom(jobDataAtom);
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom);
    const [jobUserDataPrev, setJobUserDataPrev] = useAtom(jobUserDataPrevAtom);
    const [jobOpenCommitments, setJobOpenCommitments] = useAtom(jobOpenCommitmentsAtom);
    const [jobOpenCommitmentsPrev, setJobOpenCommitmentsPrev] = useAtom(jobOpenCommitmentsPrevAtom);
    const [jobBillings, setJobBillings] = useAtom(jobBillingsAtom);
    const [jobBillingsPrev, setJobBillingsPrev] = useAtom(jobBillingsPrevAtom);
    const [jobCostDetail, setJobCostDetail] = useAtom(jobCostDetailAtom);
    const [jobCostDetailPrev, setJobCostDetailPrev] = useAtom(jobCostDetailPrevAtom);
    const [jobCostDetailCondensed, setJobCostDetailCondensed] = useAtom(jobCostDetailCondensedAtom);
    const [jobUserDetail, setJobUserDetail] = useAtom(jobUserDetailAtom);
    const [dsVersions, setDataSourceVersions] = useAtom(dataSourceVersionAtom);
    const [dsJobs, setDataSourceJobs] = useAtom(dataSourceJobsAtom);
    const [jobsClosed, setJobsClosed] = useAtom(dataSourceJobsClosedAtom);
    const [dsTeams, setDataSourceTeams] = useAtom(dataSourceTeamsAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [testJobs, setTestJobs] = useAtom(testJobsAtom);
    const [phasedForecast, setPhasedForecast] = useAtom(phasedForecastAtom);
    const [dayZero, setDayZero] = useAtom(dayZeroAtom);
    const [completionDateForecast, setCompletionDateForecast] = useAtom(projectCompleteAtom);
    const [mechanicallyCompleteGlobal, setMechanicallyComplete] = useAtom(mechanicallyCompleteAtom);
    const [startDateActualGlobal, setStartDateActual] = useAtom(startDateActualAtom);
    const [auth, setAuth] = useAtom(authStateAtom);
    const [email, setEmail] = useAtom(userEmailAtom)
    const [jobPhaseCodes, setJobPhaseCodes] = useAtom(jobPhaseCodesAtom);
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [overheadData, setOverheadData] = useAtom(overheadDataAtom);
    const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom)
    const [userSelected, setUserSelected] = useState(false);
    const [name, setName] = useAtom(userNameAtom);
    const [userId, setUserId] = useAtom(userIdAtom);
    const [userIsGood, setUserIsGood] = useAtom(userIsGoodAtom);
    const [, setUserRole] = useAtom(userRoleAtom);
    const [userEmailCheck, setUserEmailCheck] = useAtom(userEmailCheckAtom);
    const [equipmentRates, setEquipmentRates] = useAtom(equipmentRatesAtom);
    const [equipmentDescriptions, setEquipmentDescriptions] = useAtom(equipmentDescriptionsAtom);
    const [equipmentAssets, setEquipmentAssets] = useAtom(equipmentAssetsAtom);
    const [budgetDeltaWip, setBudgetDeltaWip] = useAtom(budgetDeltaWipAtom);
    const [laborDeltaWip, setLaborDeltaWip] = useAtom(laborDeltaWipAtom);
    const [equipmentDeltaWip, setEquipmentDeltaWip] = useAtom(equipmentDeltaWipAtom);
    const [materialsDeltaWip, setMaterialsDeltaWip] = useAtom(materialsDeltaWipAtom);
    const [subcontractorsDeltaWip, setSubsDeltaWip] = useAtom(subDeltaWipAtom);
    const [otherDeltaWip, setOtherDeltaWip] = useAtom(otherDeltaWipAtom);
    const [contingencyDeltaWip, setContingencyDeltaWip] = useAtom(contingencyDeltaWipAtom);
    const [overheadDeltaWip, setOverheadDeltaWip] = useAtom(overheadDeltaWipAtom);
    const [loadingCost, setLoadingCost] = useAtom(loadingCostAtom);
    const [withInLastSecond, setWithInLastSecond] = useState(false);
    const [jobLoaded, setJobLoaded] = useAtom(jobLoadedAtom);
    const [k2Data, setK2Data] = useAtom(k2DataAtom);
    const [varianceHistory, setVarianceHistory] = useAtom(varianceHistoryAtom);
    const madeIt = React.useRef(false);
    const [apiStatus, setApiStatus] = useAtom(apiStatusAtom);

    // Helper to update API status for a request. Tags every loadData call
    // with page='core' + kind='load' so the per-page indicator can group them.
    const updateApiStatus = (reqName, success, time, message = '') => {
        if (!selectedVersion || !selectedJob) return;
        const key = `${selectedVersion}_${selectedJob}`;
        setApiStatus(prev => {
            const prevEntry = prev[key] || { summary: {}, requests: [] };
            const newRequests = prevEntry.requests.filter(r => !(r.name === reqName && (r.page || 'core') === 'core'));
            newRequests.push({ name: reqName, page: 'core', kind: 'load', success, time, message, ts: Date.now() });
            const allSuccess = newRequests.length > 0 && newRequests.every(r => r.success);
            return {
                ...prev,
                [key]: {
                    summary: { success: allSuccess },
                    requests: newRequests,
                },
            };
        });
    };

    useEffect(() => {
        dsJobs && dsJobs.forEach((job) => {
            if (job.BU_ID == selectedJob) {
                if (job.BU_ID == '13525003' || job.BU_ID == '13525005' || (job.BU_ID == '13525006' && selectedVersion < 65)) {

                } else if ((job.Cat_Code_BU_18 == '3' || job.Cat_Code_BU_16 == '3') && !userSelected && !forceRegularJobs.includes(job.BU_ID) || forcePhasedJobs.includes(job.BU_ID)) {
                    setPhasedForecast('phased')
                } else {
                    setPhasedForecast('regular')
                }
            }
        })
    }, [dsJobs, selectedJob])

    useEffect(() => {
        if (selectedJob) {
            loadK2Data({ id: selectedJob }).then((d) => {
                const data = d?.data?.[0] || null;
                setK2Data(data);
            }).catch((err) => {
                console.error('loadK2Data error:', err);
                setK2Data(null);
            });
        }
    }, [selectedJob])

    useEffect(() => {
        // Check if selectedJob is a test job
        const testJob = testJobs.find(tj => tj.testJobNumber === selectedJob);
        const actualJobForData = testJob ? testJob.connectedJobNumber : selectedJob;

        const params = {
            id: selectedJob, // Use test job for user data writes
            actualJobId: actualJobForData, // Use connected job for actual costs/commitments/billings
            forecastGuid: selectedVersion,
            forecastGuidTwo: selectedWIP?.Version_GUID,
            auth: auth ? auth.idToken : '',
            live: isLiveVersion,
            wip: selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).format('YYYY-MM-DD') : '',
            isTestJob: !!testJob
        }

        //console.log('params', params, selectedJob, selectedVersion, selectedWIP?.Version_GUID,jobUserData && jobUserData.length && jobUserData[0].BU_ID == selectedJob)

        if (params.id && params.forecastGuid && selectedJob && selectedVersion && selectedWIP?.Version_GUID) {
            setJobBillings([]);
            setJobData([]);
            setJobUserDetail([]);


            // --- API STATUS TRACKING WRAPPED REQUESTS ---
            if (!(jobUserData && jobUserData.length && jobUserData[0].BU_ID == selectedJob)) {
                setJobUserData([]);
                // Not loaded until this read lands: the Overview waits on it
                // rather than showing an empty job (Seth 10/19)
                setJobLoaded(false);
                const t0 = performance.now();
                console.log('Loading user data for job', selectedJob, 'versions', params.forecastGuid, params.forecastGuidTwo);

                // Call API twice - once for current version, once for previous version
                const currentParams = { id: params.id, forecastGuid: params.forecastGuid, live: params.live };
                const prevParams = { id: params.id, forecastGuid: params.forecastGuidTwo, live: false };

                Promise.all([
                    loadUserData(currentParams),
                    loadUserData(prevParams)
                ])
                    .then(([currentData, prevData]) => {
                        const t1 = performance.now();
                        updateApiStatus('loadUserDataCombined', true, Math.round(t1 - t0));
                        const jobUserDataCurrent = currentData?.data || [];
                        const jobUserDataPrev = prevData?.data || [];
                        jobUserDataCurrent.forEach((row) => {
                            if (row.Forecast_Field_Name == 'dayZero') setDayZero(row.Forecast_Value);
                            if (row.Forecast_Field_Name == 'completionDateForecast') setCompletionDateForecast(row.Forecast_Value);
                            if (row.Forecast_Field_Name == 'startDateActual') setStartDateActual(row.Forecast_Value);
                            if (row.Forecast_Field_Name == 'mechanicallyComplete') setMechanicallyComplete(row.Forecast_Value);
                        });
                        const threeValues = completionDateForecast && startDateActualGlobal && mechanicallyCompleteGlobal ? 'three' : true;
                        setJobLoaded(threeValues);
                        setJobUserData(jobUserDataCurrent);
                        setJobUserDataPrev(jobUserDataPrev);
                    })
                    .catch((err) => {
                        const t1 = performance.now();
                        updateApiStatus('loadUserDataCombined', false, Math.round(t1 - t0), err?.message || 'Error');
                        setJobLoaded(true);
                    });
            }

            if (!(jobBillings && jobBillings.length && (jobBillings[0].Job_Number == selectedJob || (params.isTestJob && jobBillings[0].Job_Number == params.actualJobId)))) {
                const t0 = performance.now();
                // Use actualJobId (connected job) for billings when it's a test job
                const billingsParams = params.isTestJob ? { ...params, id: params.actualJobId } : params;
                loadJobBillingsCombined(billingsParams)
                    .then((data) => {
                        const t1 = performance.now();
                        updateApiStatus('loadJobBillingsCombined', true, Math.round(t1 - t0));
                        const allBillings = data?.data || [];
                        const jobBillingsPrev = allBillings.filter(item => item.Version_Guid === params.forecastGuidTwo);
                        const jobBillingsCurrent = allBillings.filter(item => item.Version_Guid === params.forecastGuid);
                        setJobBillings(jobBillingsCurrent);
                        setJobBillingsPrev(jobBillingsPrev);
                    })
                    .catch((err) => {
                        const t1 = performance.now();
                        updateApiStatus('loadJobBillingsCombined', false, Math.round(t1 - t0), err?.message || 'Error');
                    });
            }

            if (!(jobOpenCommitments && jobOpenCommitments.length && (jobOpenCommitments[0].Job_Number == selectedJob || (params.isTestJob && jobOpenCommitments[0].Job_Number == params.actualJobId)))) {
                setJobOpenCommitments([]);
                const t0 = performance.now();
                // Use actualJobId (connected job) for commitments when it's a test job
                const baseId = params.isTestJob ? params.actualJobId : params.id;

                // Call API twice - once for current version, once for previous version
                const currentParams = { id: baseId, versionGuid: params.forecastGuid };
                const prevParams = { id: baseId, versionGuid: params.forecastGuidTwo };

                Promise.all([
                    loadJobOpenCommitmentsCombined(currentParams),
                    loadJobOpenCommitmentsCombined(prevParams)
                ])
                    .then(([currentData, prevData]) => {
                        const t1 = performance.now();
                        updateApiStatus('loadJobOpenCommitmentsCombined', true, Math.round(t1 - t0));
                        const jobCommitmentsCurrent = currentData?.data || [];
                        const jobCommitmentsPrev = prevData?.data || [];
                        setJobOpenCommitments(jobCommitmentsCurrent);
                        setJobOpenCommitmentsPrev(jobCommitmentsPrev);
                    })
                    .catch((err) => {
                        const t1 = performance.now();
                        updateApiStatus('loadJobOpenCommitmentsCombined', false, Math.round(t1 - t0), err?.message || 'Error');
                    });
            }

            if (!(jobCostDetail && jobCostDetail.length && jobCostDetail[0].Job_Number == selectedJob)) {
                setJobCostDetail([]);
                setLoadingCost(true);
                const t0 = performance.now();

                // Call API twice - once for current version, once for previous version
                const currentParams = { id: params.id, versionGuid: params.forecastGuid };
                const prevParams = { id: params.id, versionGuid: params.forecastGuidTwo };

                Promise.all([
                    loadCostHistoryCombined(currentParams),
                    loadCostHistoryCombined(prevParams)
                ])
                    .then(([currentData, prevData]) => {
                        //console.log('loaded cost detail for job', currentData)
                        const t1 = performance.now();
                        updateApiStatus('loadCostHistoryCombined', true, Math.round(t1 - t0));
                        const jobCostDetailCurrent = currentData?.data || [];
                        const jobCostDetailPrev = prevData?.data || [];
                        //console.log('loaded cost detail', jobCostDetailCurrent);
                        setJobCostDetail(jobCostDetailCurrent);
                        setJobCostDetailPrev(jobCostDetailPrev);
                        setLoadingCost(false);
                    })
                    .catch((err) => {
                        const t1 = performance.now();
                        updateApiStatus('loadCostHistoryCombined', false, Math.round(t1 - t0), err?.message || 'Error');
                        setLoadingCost(false);
                    });
            }

            // Load condensed cost detail for bidForecast and overview pages
            if (!(jobCostDetailCondensed && jobCostDetailCondensed.length && jobCostDetailCondensed[0]?.Job_Number == selectedJob)) {
                const t0 = performance.now();
                loadCostDetailCondensed({ jobNumber: selectedJob, versionGuid: selectedVersion })
                    .then((data) => {
                        const t1 = performance.now();
                        updateApiStatus('loadCostDetailCondensed', true, Math.round(t1 - t0));
                        setJobCostDetailCondensed(data?.data || []);
                    })
                    .catch((err) => {
                        const t1 = performance.now();
                        updateApiStatus('loadCostDetailCondensed', false, Math.round(t1 - t0), err?.message || 'Error');
                        setJobCostDetailCondensed([]);
                    });
            }

            // The job's own chart names (e.g. 54026071's 'Qpac 07-01 Prep'), not another job's name for the same code
            loadPhaseCodes({ jobNumber: params.actualJobId }).then((data) => {
                //console.log('phase codes', data.data)
                const phaseCodes = {}
                data?.data?.forEach((row) => {
                    phaseCodes[row.Phase_Code] = row.Phase_Code_Description
                })

                setJobPhaseCodes(phaseCodes);
            })

            loadOverheadData({ forecastGuid: selectedVersion }).then((data) => {
                const ohValues = {}
                data?.data?.forEach((d) => {
                    if (ohValues[d?.Forecast_Row_ID]) {
                        ohValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                    } else {
                        ohValues[d?.Forecast_Row_ID] = {
                            id: d?.Forecast_Row_ID,
                            [d.Forecast_Field_Name]: d.Forecast_Value
                        }
                    }
                })

                //console.log('oh values', ohValues)
                const oh = {}
                Object.values(ohValues).forEach((value) => {
                    oh[value.team] = value.percent
                })
                setOverheadData(oh);
            })

            loadEquipmentData({ forecastGuid: selectedVersion }).then((data) => {
                const rData = {}
                data?.data?.forEach((d) => {
                    if (d?.Forecast_Tab === 'Equipment') {
                        if (rData[d?.Forecast_Row_ID]) {
                            rData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else {
                            rData[d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        }
                    }
                })

                const rates = {}
                const assetDescriptions = {}
                Object.values(rData).forEach((row, index) => {
                    rates[row['Equipment Tier']] = row['Current Hourly Billing Rate']
                    if (row['Asset Description']) {
                        assetDescriptions[row['Equipment Tier']] = row['Asset Description']
                    }
                })

                //if (!equipmentAssets || equipmentAssets.length == 0) {
                setEquipmentRates(rates)
                setEquipmentDescriptions(assetDescriptions)
                setEquipmentAssets(Object.keys(rates).map(tier => ({
                    value: tier,
                    label: assetDescriptions[tier] ? tier + ' - ' + assetDescriptions[tier] : tier
                })))
                //}

                // saveEquipmentRates(rates)
                // saveEquipmentAssets(Object.keys(rates))
            })

            const t2 = performance.now();
            loadVariance(params)
                .then((data) => {
                    const t3 = performance.now();
                    updateApiStatus('loadVariance', true, Math.round(t3 - t2));
                    //console.log('wip data', data)

                    // Reset every group first: a job with no postings in a group (e.g. no
                    // 55xxx accounts) returns no row for it, and the atom would otherwise
                    // keep the previously viewed job's value.
                    setBudgetDeltaWip(null)
                    setLaborDeltaWip(null)
                    setEquipmentDeltaWip(null)
                    setMaterialsDeltaWip(null)
                    setSubsDeltaWip(null)
                    setOtherDeltaWip(null)
                    setContingencyDeltaWip(null)
                    setOverheadDeltaWip(null)
                    if (data?.variance && data.variance.length > 0) {
                        data.variance.forEach((d) => {
                            if (d?.Account_Group === '41000') {
                                //console.log('budget', d?.Total_Amount)
                                setBudgetDeltaWip(-1 * pNum(d?.Total_Amount))
                            } else if (d?.Account_Group === '51000') {
                                //console.log('labor', d?.Total_Amount)
                                setLaborDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '52000') {
                                //console.log('equipment', d?.Total_Amount)
                                setEquipmentDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '53000') {
                                //console.log('materials', d?.Total_Amount)
                                setMaterialsDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '54000') {
                                //console.log('subs', d?.Total_Amount)
                                setSubsDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '55000') {
                                //console.log('other', d?.Total_Amount)
                                setOtherDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '101101') {
                                //console.log('contingency', d?.Total_Amount)
                                setContingencyDeltaWip(d?.Total_Amount)
                            } else if (d?.Account_Group === '60900') {
                                //console.log('overhead', d?.Total_Amount)
                                setOverheadDeltaWip(d?.Total_Amount)
                            }
                        })
                    }
                

                // // const phaseCodes = {}
                // // data?.phases?.forEach((row) => {
                // //     phaseCodes[row.Phase_Code] = true
                // // })
                // // setJobPhaseCodes(phaseCodes);

                // const rData = {}
                // data?.equipmentRates?.forEach((d) => {
                //     if (d?.Forecast_Tab === 'Equipment') {
                //         if (rData[d?.Forecast_Row_ID]) {
                //             rData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                //         } else {
                //             rData[d?.Forecast_Row_ID] = {
                //                 id: d?.Forecast_Row_ID,
                //                 [d.Forecast_Field_Name]: d.Forecast_Value
                //             }
                //         }
                //     }
                // })

                // const rates = {}
                // Object.values(rData).forEach((row, index) => {
                //     rates[row['Equipment Tier']] = row['Current Hourly Billing Rate']
                // })

                // // if (!equipmentAssets || equipmentAssets.length == 0) {
                // //     console.log('rates', rates)
                // //     setEquipmentRates(rates)
                // //     setEquipmentAssets(Object.keys(rates))
                // // }

                // //console.log('seth rates', rates)

                // saveEquipmentRates(rates)
                // saveEquipmentAssets(Object.keys(rates))
                // setEquipmentAssets(Object.keys(rates))
                // setEquipmentRates(rates)

                // const ohValues = {}
                // data?.overhead?.forEach((d) => {
                //     if (ohValues[d?.Forecast_Row_ID]) {
                //         ohValues[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                //     } else {
                //         ohValues[d?.Forecast_Row_ID] = {
                //             id: d?.Forecast_Row_ID,
                //             [d.Forecast_Field_Name]: d.Forecast_Value
                //         }
                //     }
                // })

                // const oh = {}
                // Object.values(ohValues).forEach((value) => {
                //     oh[value.team] = value.percent
                // })
                // setOverheadData(oh);
                })
        .catch((err) => {
            const t3 = performance.now();
            updateApiStatus('loadVariance', false, Math.round(t3 - t2), err?.message || 'Error');
            console.error('loadVariance error:', err);
            // Don't let a failed load leave the previous job's prev-WIP values on screen
            setBudgetDeltaWip(null)
            setLaborDeltaWip(null)
            setEquipmentDeltaWip(null)
            setMaterialsDeltaWip(null)
            setSubsDeltaWip(null)
            setOtherDeltaWip(null)
            setContingencyDeltaWip(null)
            setOverheadDeltaWip(null)
        });

}
    }, [selectedJob, selectedVersion, selectedWIP, testJobs])

// Load variance history for multiple versions to create line graph
// useEffect(() => {
//     if (!selectedJob || !dsVersions || dsVersions.length === 0) return;

//     // Get the last 10-15 WIP-locked versions for the selected job
//     const versionsToLoad = dsVersions
//         .filter(v => v.Version_Start_DateTime && v.Version_Type === 'WIP-locked') // Only WIP-locked versions with dates
//         .sort((a, b) => moment(b.Version_Start_DateTime).diff(moment(a.Version_Start_DateTime))) // Sort newest first
//         .slice(0, 15); // Take last 15 versions

//     if (versionsToLoad.length === 0) return;

//     console.log('Loading variance history for', versionsToLoad.length, 'versions');

//     // Load variance for each version
//     const variancePromises = versionsToLoad.map((version) => {
//         const params = {
//             id: selectedJob,
//             wip: moment(version.Version_Start_DateTime).format('YYYY-MM-DD')
//         };

//         return loadVariance(params)
//             .then((data) => {
//                 // Calculate GM variance from the data
//                 let revenue = 0;
//                 let costs = 0;

//                 data?.variance?.forEach((d) => {
//                     if (d?.Account_Group === '41000') {
//                         revenue = -1 * pNum(d?.Total_Amount);
//                     } else if (d?.Account_Group === '51000' || d?.Account_Group === '52000' ||
//                         d?.Account_Group === '53000' || d?.Account_Group === '54000' ||
//                         d?.Account_Group === '55000' || d?.Account_Group === '60900') {
//                         costs += pNum(d?.Total_Amount);
//                     }
//                 });

//                 const gm = revenue - costs;
//                 const gmPercent = revenue !== 0 ? (gm / revenue) * 100 : 0;

//                 return {
//                     versionGuid: version.Version_GUID,
//                     versionDate: version.Version_Start_DateTime,
//                     versionName: version.Version_Name || 'V' + version.Version_GUID,
//                     revenue,
//                     costs,
//                     gm,
//                     gmPercent,
//                     // Include individual cost categories for more detailed graphing
//                     budget: revenue,
//                     labor: data?.variance?.find(d => d?.Account_Group === '51000')?.Total_Amount || 0,
//                     equipment: data?.variance?.find(d => d?.Account_Group === '52000')?.Total_Amount || 0,
//                     materials: data?.variance?.find(d => d?.Account_Group === '53000')?.Total_Amount || 0,
//                     subcontractors: data?.variance?.find(d => d?.Account_Group === '54000')?.Total_Amount || 0,
//                     other: data?.variance?.find(d => d?.Account_Group === '55000')?.Total_Amount || 0,
//                     overhead: data?.variance?.find(d => d?.Account_Group === '60900')?.Total_Amount || 0,
//                     contingency: data?.variance?.find(d => d?.Account_Group === '101101')?.Total_Amount || 0
//                 };
//             })
//             .catch((err) => {
//                 console.error('Error loading variance for version', version.Version_GUID, err);
//                 return null;
//             });
//     });

//     Promise.all(variancePromises)
//         .then((results) => {
//             // Filter out null results and sort by date
//             const validResults = results
//                 .filter(r => r !== null)
//                 .sort((a, b) => moment(a.versionDate).diff(moment(b.versionDate)));

//             console.log('Variance history loaded:', validResults.length, 'versions');
//             setVarianceHistory(validResults);
//         })
//         .catch((err) => {
//             console.error('Error loading variance history:', err);
//         });
// }, [selectedJob, dsVersions])

useEffect(() => {
    // selected version
    console.log('made it called load data', dsJobs, madeIt.current)
    if (!(dsJobs && dsJobs.length) /*&& selectedVersion != null*/ && !madeIt.current) {
        console.log('here 2')
        madeIt.current = true;

        // Try to get cached data first
        const cachedData = getCachedVersionTeamJob();

        if (cachedData) {
            // Use cached data
            if (!(dsVersions && dsVersions.length)) {
                //console.log('using cached versions', cachedData.versions)
                setDataSourceVersions(cachedData.versions);
            }

            if (!(dsTeams && dsTeams.length)) {
                const sorted = cachedData.teams?.sort((a, b) => {
                    if (a.Cat_Code_BU_21 < b.Cat_Code_BU_21) {
                        return -1;
                    }
                    if (a.Cat_Code_BU_21 > b.Cat_Code_BU_21) {
                        return 1;
                    }
                    return 0;
                }).filter((team) => team.Cat_Code_BU_21_Description != '.')
                console.log('sorted teams from cache', sorted)
                setDataSourceTeams(sorted);
            }

            if (cachedData.jobsClosed && cachedData.jobsClosed.length >= 0) {
                setJobsClosed(cachedData.jobsClosed);
            }

            if (cachedData.jobs) {
                setDataSourceJobs(cachedData.jobs);
            }
        } else {
            // Fetch fresh data
            Promise.all([
                loadVersionTeamJob({ forecastGuid: selectedVersion }),
                loadJobsNew({ forecastGuid: selectedVersion })
            ]).then(([jobsData, jobsNewData]) => {
                //.then((jobsData) => {
                if (!(dsVersions && dsVersions.length)) {
                    setDataSourceVersions(jobsData.version);
                }

                if (!(dsTeams && dsTeams.length)) {
                    const sorted = jobsData.teams?.sort((a, b) => {
                        if (a.Cat_Code_BU_21 < b.Cat_Code_BU_21) {
                            return -1;
                        }
                        if (a.Cat_Code_BU_21 > b.Cat_Code_BU_21) {
                            return 1;
                        }
                        return 0;
                    }).filter((team) => team.Cat_Code_BU_21_Description != '.')
                    //console.log('sorted teams', sorted)
                    //seth
                    setDataSourceTeams(sorted);
                }



                console.log('loaded jobs closed', jobsData)
                if (jobsData.jobsClosed?.length == 0) {
                    setJobsClosed(jobsData.jobsClosed);
                }

                const jobDetails = {};
                const jobNewDetails = {}
                const projectManagers = {};
                console.log('first jobs', [jobsData.jobs, jobsNewData.data])
                jobsData.jobs && jobsData.jobs.forEach((job) => {
                    if (job.Cat_Code_BU_08 != 'JW' && job.Cat_Code_BU_08 != 'JX') {
                        jobDetails[job.BU_ID] = job
                    }

                    if (job.Project_Manager_Name) {
                        if (!projectManagers[job.Project_Manager_Name]) {
                            projectManagers[job.Project_Manager_Name] = [];
                        }
                        projectManagers[job.Project_Manager_Name].push(job.BU_ID);
                    }
                })

                jobsNewData.data && jobsNewData.data.forEach((job) => {
                    jobNewDetails[job.BU_ID] = job
                    if (!jobDetails[job.BU_ID]) {
                        if (job.Cat_Code_BU_08 != 'JW' && job.Cat_Code_BU_08 != 'JX') {
                            jobDetails[job.BU_ID] = job
                        }
                    } else {
                        jobDetails[job.BU_ID].Cat_Code_BU_38_Description = job.Cat_Code_BU_38_Description
                        jobDetails[job.BU_ID].Cat_Code_BU_10_Description = job.Cat_Code_BU_10_Description
                        if (job.Scope_of_Work) {
                            jobDetails[job.BU_ID].Scope_of_Work = job.Scope_of_Work
                        }
                        // First query sometimes returns Cat_Code_BU_27 ("team") empty;
                        // backfill from the new query when it has a value and the existing is blank.
                        if (job.Cat_Code_BU_27 && !jobDetails[job.BU_ID].Cat_Code_BU_27) {
                            jobDetails[job.BU_ID].Cat_Code_BU_27 = job.Cat_Code_BU_27
                        }
                    }

                    if (job.Project_Manager_Name) {
                        if (!projectManagers[job.Project_Manager_Name]) {
                            projectManagers[job.Project_Manager_Name] = [];
                        }
                        if (!projectManagers[job.Project_Manager_Name].includes(job.BU_ID)) {
                            projectManagers[job.Project_Manager_Name].push(job.BU_ID);
                        }
                    }
                })


                console.log('project Managers:', projectManagers);
                console.log('all jobs ', jobsData.jobs ? [...jobsData.jobs] : [])//, ...jobsNewData.data])
                console.log('selectedVersion', selectedVersion, jobDetails)

                const finalJobs = Object.values(jobDetails);
                setDataSourceJobs(finalJobs);

                // Cache the loaded data
                const sortedTeams = jobsData.teams?.sort((a, b) => {
                    if (a.Cat_Code_BU_21 < b.Cat_Code_BU_21) {
                        return -1;
                    }
                    if (a.Cat_Code_BU_21 > b.Cat_Code_BU_21) {
                        return 1;
                    }
                    return 0;
                }).filter((team) => team.Cat_Code_BU_21_Description != '.');

                // Only cache a genuinely successful read. The Azure Function
                // returns HTTP 200 with { error } on failure, so a failed fetch
                // looks like success and would otherwise be cached for an hour
                // (see isCacheValid) — pinning the app to empty data and
                // suppressing retries. Guard on a real version payload.
                const fetchOk = jobsData && !jobsData.error && Array.isArray(jobsData.version) && jobsData.version.length;
                if (fetchOk) {
                    setCachedVersionTeamJob({
                        versions: jobsData.version,
                        teams: sortedTeams,
                        jobsClosed: jobsData.jobsClosed,
                        jobs: finalJobs
                    });
                }
            });
        }


        // loadVersionTeamJob({ forecastGuid: selectedVersion }).then((data) => {
        //     if (!(dsVersions && dsVersions.length)) {
        //         setDataSourceVersions(data.version);
        //     }

        //     if (!(dsTeams && dsTeams.length)) {
        //         const sorted = data.teams?.sort((a, b) => {
        //             if (a.Cat_Code_BU_21 < b.Cat_Code_BU_21) {
        //                 return -1;
        //             }
        //             if (a.Cat_Code_BU_21 > b.Cat_Code_BU_21) {
        //                 return 1;
        //             }
        //             return 0;
        //         }).filter((team) => team.Cat_Code_BU_21_Description != '.')

        //         //console.log('sorted teams', sorted, data)
        //         setDataSourceTeams(sorted);


        //     }

        //     setJobsClosed(data.jobsClosed);

        //     loadJobsNew({ forecastGuid: selectedVersion }).then((dataNew) => {
        //         console.log('loaded new jobs', data, dataNew)
        //         const jobDetails = {}
        //         const jobNewDetails = {}
        //         data.jobs && data.jobs.forEach((job) => {
        //             if (job.Cat_Code_BU_08 != 'JW' && job.Cat_Code_BU_08 != 'JP' || job.Cat_Code_BU_08 != 'JX') {
        //                 jobDetails[job.BU_ID] = job
        //             }
        //         })

        //         dataNew.data && dataNew.data.forEach((job) => {
        //             jobNewDetails[job.BU_ID] = job
        //             if (!jobDetails[job.BU_ID]) {
        //                 if (job.Cat_Code_BU_08 != 'JW' && job.Cat_Code_BU_08 != 'JP' || job.Cat_Code_BU_08 != 'JX') {
        //                     jobDetails[job.BU_ID] = job
        //                 }
        //             }
        //         })

        //         console.log('jobs', data.jobs.length, dataNew.data.length)
        //         const projectManagers = {};

        //         data.jobs.forEach((job) => {
        //             if (job.Project_Manager_Name) {
        //                 if (!projectManagers[job.Project_Manager_Name]) {
        //                     projectManagers[job.Project_Manager_Name] = [];
        //                 }
        //                 projectManagers[job.Project_Manager_Name].push(job.BU_ID);
        //             }
        //         });


        //         dataNew.data.forEach((job) => {
        //             if (job.Project_Manager_Name) {
        //                 if (!projectManagers[job.Project_Manager_Name]) {
        //                     projectManagers[job.Project_Manager_Name] = [];
        //                 }
        //                 if (!projectManagers[job.Project_Manager_Name].includes(job.BU_ID)) {
        //                     projectManagers[job.Project_Manager_Name].push(job.BU_ID);
        //                 }
        //             }
        //         });

        //         console.log('Project Managers and their jobs:', jobDetails);
        //         setDataSourceJobs(Object.values(jobDetails));
        //     })
        // })
    }
}, [selectedVersion])

useEffect(() => {
    if (auth && auth.decoded?.email) {
        //console.log('here is the email', auth.decoded.email)
        setUserEmailCheck(auth.decoded.email?.toLowerCase())
        // The signed-in address, for everything that has to name the person
        // rather than look them up (the Ticket Map's test send, audit stamps).
        // main.js only sets this on MSAL's silent-token path, which doesn't
        // run after an interactive sign-in — so the token we already have
        // is the reliable source.
        setEmail(auth.decoded.email)
        loadUserEmailData({ email: auth.decoded.email }).then((data) => {
            //console.log('user email data', data)
            const id = data?.data?.[0]?.Forecast_User_ID ? data?.data?.[0]?.Forecast_User_ID : ''
            const firstName = data?.data?.[0]?.Forecast_User_First_Name ? data?.data?.[0]?.Forecast_User_First_Name.trim() : ''
            const lastName = data?.data?.[0]?.Forecast_User_Last_Name ? data?.data?.[0]?.Forecast_User_Last_Name.trim() : ''
            const email = auth.decoded.email ? auth.decoded.email : ''

            // Only overwrite the MSAL-derived identity (set in main.js) when the
            // SQL Forecast_User lookup actually returned a row. Otherwise we'd
            // wipe a real user like Meghan to '' / ' ', and every audit row
            // they save would fall back to the hardcoded 'Seth Bailey'.
            if (data?.foundUser) {
                setUserId(id);
                setName((firstName + ' ' + lastName).trim());
            }
            setUserIsGood(data?.foundUser);
            // Role from PC.Forecast_Users (falls back to the row's column if the
            // API hasn't been redeployed yet). '' = standard user.
            setUserRole(data?.role || data?.data?.[0]?.Forecast_User_Role || '');

            // Login history — one grouped row per person per LOCAL calendar day,
            // in a dedicated non-versioned table (PC.Forecast_Audit_Login,
            // companion to PC.Forecast_Audit_Log). Recorded regardless of
            // whether a job/version is selected.
            const d = new Date();
            const localLoginDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            recordLogin({
                userEmail: email,
                userName: (firstName + ' ' + lastName).trim(),
                userId: id,
                loginDate: localLoginDate,
                buId: selectedJob || null,
                version: (selectedJob && selectedVersion) ? selectedVersion + '' : null,
            }).catch(() => {});

            // ── DISABLED: old login-trace write into the VERSIONED table.
            // This wrote a 'Test' tab row with a random rowId on every load
            // (insert-only, stamped with the currently-open version), which
            // bloated PCV.Forecast_User_Data (~49k rows in v102 alone) and
            // polluted real versions. Replaced by recordLogin() above.
            // if (!selectedJob || !selectedVersion) return;
            // const randomRowId = Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000 + ''
            // const userInfo = {
            //     userId: '154045',
            //     userName: 'Seth Bailey',
            //     userEmail: email,
            //     fieldName: 'userInfo',
            //     tab: "Test",
            //     rowId: randomRowId,
            //     version: selectedVersion + '',
            //     value: id + ' ' + firstName + ' ' + lastName + ' ' + email,
            //     id: selectedJob
            // }
            // updateUserDataArray(userInfo)
        })
    }
}, [auth, selectedJob, selectedVersion])

return null
}

export default LoadData;

